import MoleculeStructure from '../../Data/MoleculeStructure';
import { TableData } from '../DataTable';
import DetailsModal from '../../Popups/DetailsModal';
import { ReactComponent as ExpandIcon } from '../../../assets/Icons/adornments/Expand.svg';
import { useLocation, useNavigate } from 'react-router-dom';

export default function StructureCell({
    data,
    value,
    threshold,
    index,
    setPopupMessage,
    moleculeHighlightingModelFamily,
    id,
    hasPadding,
}: {
    data?: TableData,
    value: string,
    threshold?: number,
    index: number,
    setPopupMessage?: (popupMessage: string, isSuccessMessage: boolean) => void,
    moleculeHighlightingModelFamily?: number | null,
    id?: string,
    hasPadding: boolean,
}) {
    const navigate = useNavigate();
    const { pathname } = useLocation();

    const goToPrediction = () => {
        const pathnameArr = pathname.split('/');
        const resultsetId = pathnameArr[pathnameArr.length-1];
        if (moleculeHighlightingModelFamily) {
            const encodedSmiles = encodeURIComponent(value);
            navigate(`/resultsets/${resultsetId}/prediction/${moleculeHighlightingModelFamily}/${encodedSmiles}`)
        };
    }

    return (
            <div className={`${hasPadding ? 'py-4 px-6' : ''} flex justify-start items-start gap-2`}>
                {index === 0 ? (
                    <div className='relative z-40'>
                    {moleculeHighlightingModelFamily ? (
                        <button onClick={goToPrediction} className='w-[18px] text-highlight hover:text-primary transition-all'>
                            <ExpandIcon/>
                        </button>
                    ) : setPopupMessage && data ? (
                        <DetailsModal 
                            threshold={threshold}
                            data={data}
                            isGridItem={false}
                            setPopupMessage={setPopupMessage}
                        />
                    ) : (
                        <></>
                    )}
                    </div>
                ) : (
                    <></>
                )}
                <div><MoleculeStructure width={150} height={150} smiles={value} id={id}/></div>
            </div>
    )
}